import { createSlice } from "@reduxjs/toolkit";
import { fetchDistrictInchargeItemRequest } from "./thunk";

interface initialStateType {
  itemDistrictInchargeRequestList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: initialStateType = {
  itemDistrictInchargeRequestList: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const DistrictInchargeItemRequestSlice = createSlice({
  name: "DistrictInchargeItemRequest",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDistrictInchargeItemRequest.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDistrictInchargeItemRequest.fulfilled, (state, action) => {
        state.loading = false;
        state.itemDistrictInchargeRequestList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchDistrictInchargeItemRequest.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "Network Error";
      })
  },
});

export default DistrictInchargeItemRequestSlice.reducer;
